import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_CONFIG = {
  serviceID: 'service_blerx6p',
  templateID: 'template_5j5iodz',
  publicKey: 'T3Uyu60DYuAQMr9sy'
};

// Initialize EmailJS (call this once when the app starts)
export const initEmailJS = () => {
  emailjs.init(EMAILJS_CONFIG.publicKey);
};

// Send contact form email
export const sendContactEmail = async (formData: {
  name: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}) => {
  const templateParams = {
    from_name: formData.name,
    from_email: formData.email,
    phone: formData.phone || 'Not provided',
    subject: formData.subject || 'Website Contact Form',
    message: formData.message,
    to_email: 'rob@dixonfinancialservices.com'
  };

  return emailjs.send(
    EMAILJS_CONFIG.serviceID,
    EMAILJS_CONFIG.templateID,
    templateParams,
    EMAILJS_CONFIG.publicKey
  );
}; 